import { render, staticRenderFns } from "./priceLabelTheme.vue?vue&type=template&id=88949d9c&scoped=true"
import script from "./priceLabelTheme.vue?vue&type=script&lang=js"
export * from "./priceLabelTheme.vue?vue&type=script&lang=js"
import style0 from "./priceLabelTheme.vue?vue&type=style&index=0&id=88949d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88949d9c",
  null
  
)

export default component.exports